'use strict'

const currentPage = window.location.pathname;
const navLinks = document.querySelectorAll('.nav-link, .btn-contact');
const logoLink = document.querySelector('.logo-link');
const btnBackToTop = document.querySelector('.btn-back-to-top');

// Button back to top
window.addEventListener("scroll", () => {
    if (window.scrollY > 300) {
        btnBackToTop.classList.add("active")
    } else {
        btnBackToTop.classList.remove("active")
    }
})

btnBackToTop.addEventListener('click', () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
})

// Scroll to element
;[...navLinks].forEach((navLink) =>
    navLink.addEventListener('click', function () {
        const sectionTopPosition = document.getElementById(this.dataset.section).getBoundingClientRect().top;
        window.scrollTo({
            top: sectionTopPosition + window.scrollY,
            behavior: "smooth"
        })
    })
)

// Prevent refresh page on click if already on homepage
if (currentPage === '/') {
    logoLink.addEventListener('click', (e) => {
        e.preventDefault()
    })
    logoLink.style.pointerEvents = 'none'
}
